import { render, staticRenderFns } from "./ReportDataTable.vue?vue&type=template&id=36c9d191&"
import script from "./ReportDataTable.vue?vue&type=script&lang=js&"
export * from "./ReportDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportDataTable.vue?vue&type=style&index=0&id=36c9d191&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports